import { ReportVisibility, ReportSwell, ReportWind } from "../../../models";
import { FormsT } from "../form/FormTypes";

export const Fields: Array<FormsT> = [
    {
        type: "date",
        title: "Report date",
        property: "date",
    },
    {
        type: "rating",
        title: "Overall rating",
        property: "rating",
    },
    {
        type: "optionalNumber",
        title: "Water temp",
        property: "waterTemp",
        placeholder: "Temperature in Celsius",
    },
    {
        type: "enumSelect",
        title: "Visibility",
        property: "visibility",
        enumType: ReportVisibility,
    },
    {
        type: "enumSelect",
        title: "Swell",
        property: "swell",
        enumType: ReportSwell,
        visible: "tidal",
    },
    {
        type: "enumSelect",
        title: "Wind",
        property: "wind",
        enumType: ReportWind,
        visible: "tidal",
    },
    {
        type: "textArea",
        title: "Details",
        property: "text",
    },
];
